export default __webpack_public_path__ + "static/N0130-7b1c6fe23ad92e33f0ebe93f94316ac7.png";